module.exports = __webpack_public_path__ + "static/img/onlineicon.53abac9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/onlineicon.png
// module id = Pg8E
// module chunks = 1